import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { item } from '../../models/item';
import { environment } from '../../../../environments/environment';
import { take } from 'rxjs';
import { Page } from '../../../shared/models/page.model';
import { PageEvent } from '@angular/material/paginator';

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  constructor(private http: HttpClient) { }

  itemsUrl: string = `${environment.apiUrl}/api/items`

  createItem(item: item) {
    return this.http.post<item>(`${this.itemsUrl}/create`,item).pipe(take(1))
  }

  listItemsPaginated(pager: PageEvent) {
    let params = new HttpParams()
    .append('page', pager.pageIndex)
    .append('size', pager.pageSize)

    return this.http.get<Page<item>>(`${this.itemsUrl}/list`, {params}).pipe(take(1))
  }

  listItemsPaginatedandFiltered(pager: PageEvent, filter?: string) {
    let params = new HttpParams()
    .append('page', pager.pageIndex)
    .append('size', pager.pageSize)
    .append('filter', filter ? filter : '');

    return this.http.get<Page<item>>(this.itemsUrl, {params}).pipe(take(1));
  }

  updateItem(item: item, id: number) {
    return this.http.put<item>(`${this.itemsUrl}/${id}`, item).pipe(take(1))
  }

  updateItemWithImage(formData: FormData, id: number) {
    return this.http.put(`${this.itemsUrl}/${id}`, formData).pipe(take(1));
  }

  deleteItem(item: item, id: number) {
    return this.http.put<item>(`${this.itemsUrl}/deactivate/${id}`, item).pipe(take(1))
  }
  getItemImage(idItem?: number){
    return this.http.get(`${this.itemsUrl}/images?idItem=${idItem}`,{responseType:'blob'}).pipe(take(1))
  }

  getItemImageUrl(filename: string): string {
    return `${this.itemsUrl}/images?filename=${filename}`;
  }

  getItemById(id?: number) {
    return this.http.get<item>(`${this.itemsUrl}/details-item/${id}`).pipe(take(1))
  }
  createItemWithImage(formData: FormData) {
    return this.http.post(`${this.itemsUrl}/create`, formData).pipe(take(1));
  }


}

